import {
  DEFAULT_INLINE_ICON_SIZE_CODE,
  InlineIconConfig,
  InlineIconSizeCode,
  INLINE_ICON_SIZE_PX,
} from "./DefaultConfig";

const SIZE_ALIASES: Record<string, InlineIconSizeCode> = {
  S: "S",
  SMALL: "S",
  M: "M",
  MEDIUM: "M",
  L: "L",
  LARGE: "L",
  XL: "XL",
};

/** Resolves inline icon metadata from embedded data or parent pluginConfigs by ref. */
export function resolveInlineIconMetadata(
  elementData: { ref?: string; metadata?: InlineIconConfig } | undefined,
  pluginConfigs?: Record<string, InlineIconConfig>,
): InlineIconConfig | undefined {
  if (elementData?.metadata) {
    return elementData.metadata;
  }

  const ref = elementData?.ref;
  if (ref && pluginConfigs?.[ref]) {
    return pluginConfigs[ref];
  }

  return undefined;
}

/** Maps config size (S/M/L/XL or legacy numeric pixels) to a size code for CSS classes. */
export function resolveInlineIconSizeCode(size?: string | number): InlineIconSizeCode {
  if (typeof size === "number" && size > 0) {
    const matchedEntry = Object.entries(INLINE_ICON_SIZE_PX).find(([, px]) => px === size);
    return matchedEntry ? (matchedEntry[0] as InlineIconSizeCode) : DEFAULT_INLINE_ICON_SIZE_CODE;
  }

  if (typeof size === "string" && size.trim()) {
    const normalized = size.trim().toUpperCase();
    return SIZE_ALIASES[normalized] ?? DEFAULT_INLINE_ICON_SIZE_CODE;
  }

  return DEFAULT_INLINE_ICON_SIZE_CODE;
}
